import Intl from 'intl';
import 'intl/locale-data/jsonp/pt-BR';

export const toReal = (value) => {
  if (!value) {
    return 'R$ 0,00';
  }

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};

export const percent = (value) =>
  new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);

export const stringToDate = (string) => {
  if (string) {
    const year = string.substring(0, 4);
    const month = string.substring(5, 7);
    const day = string.substring(8, 10);
    const result = `${day}/${month}/${year}`;
    return result
  }
  
  return '';
};